module.exports = __webpack_public_path__ + "img/pic3.8c58d9a9.jpg";